// @flow
import { store } from '../App';
import { APP_INSTALLED, SHOW_INSTALL_PROMPT } from '../actions/types';
// import { setCookie } from '../utils';
import { firebase } from '../context/firebase.js';

window.addEventListener('beforeinstallprompt', (e) => {
	e.preventDefault();
	store.dispatch({
		type: SHOW_INSTALL_PROMPT,
		payload: e,
	});
});

window.addEventListener('appinstalled', () => {
	store.dispatch({
		type: APP_INSTALLED,
	});

  if (firebase) {
    firebase.analytics().setUserProperties({ tm_launch: 'installed_app' });
  }
});

let refreshing = false;
export const onUpdate = (registration: any) => {
	if (refreshing) return;
	window.location.reload();
	refreshing = true;
};
